import { ClipboardText, Path, ChatCircleDots, ArrowsClockwise } from "@phosphor-icons/react";

const steps = [
  { n: "01", icon: ClipboardText, t: "Day 1 — Intake", d: "Fill out the Sweat With Slay intake. Takes ~15 min. I review it personally within 48 hours." },
  { n: "02", icon: Path, t: "Day 2-3 — Your plan", d: "I build your custom program around your goals, schedule, equipment & lifestyle. Delivered through Everfit." },
  { n: "03", icon: ChatCircleDots, t: "Week 1 — First check-in", d: "End-of-week feedback. We dial in form, intensity, recovery. Adjust anything that's not working." },
  { n: "04", icon: ArrowsClockwise, t: "Month 1+ — Iterate & win", d: "Weekly accountability, monthly program updates, real-time adjustments as your life changes." },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative px-6 md:px-12 lg:px-20 py-16 lg:py-20 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#FF1B91]" />
            <p className="text-[11px] uppercase tracking-[0.4em] text-[#FF1B91] font-semibold">How It Works</p>
            <span className="h-px w-10 bg-[#FF1B91]" />
          </div>
          <h2 className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.9] tracking-tighter mb-4">
            From intake to{" "}
            <span className="font-brush font-normal normal-case text-[#FF1B91] inline-block transform -rotate-2">first win.</span>
          </h2>
          <p className="text-white/70 max-w-xl mx-auto">Here's exactly what happens after you fill out the intake.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.n} data-testid={`step-${s.n}`} className="relative border border-white/10 bg-[#0F0F0F] hover:border-[#FF1B91] transition-all p-7">
                <div className="font-display font-black text-[#FF1B91]/30 text-6xl absolute top-4 right-5 leading-none">{s.n}</div>
                <div className="w-11 h-11 border border-white/15 flex items-center justify-center text-[#FF1B91] mb-6 relative z-10">
                  <Icon size={20} weight="bold" />
                </div>
                <h3 className="font-body font-semibold text-lg mb-3 leading-snug">{s.t}</h3>
                <p className="text-sm text-white/65 leading-relaxed">{s.d}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
